import React, { ReactNode } from 'react';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { WprRadio } from '../../wpr-framework/component/controls/WprRadio';
import { WprContainer } from '../../wpr-framework/component/controls/WprContainer';
import { PlanComponentView } from './PlanComponentView';
import { withRouter } from 'react-router';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { WprCheckBox } from '../../wpr-framework/component/controls/WprCheckBox';
import { FooterComponent } from '../common/footer/FooterComponent';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
import { WprLi } from '../../wpr-framework/component/controls/WprLi';
import { WprText } from '../../wpr-framework/component/controls/WprText';
import { WprAnchor } from '../../wpr-framework/component/controls/WprAnchor';
import { WprRowInfo } from '../../wpr-framework/component/props/WprRowInfo';

/**
 * 3.プラン
 */
class PlanComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new PlanComponentView(), props);
	}

	public handleClick = (e: React.MouseEvent, props) => {
		e.nativeEvent.stopImmediatePropagation();
		const targetId = e.currentTarget.id;
		$('#' + targetId.replace('-lbl', '')).off('click');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
     * 描画
     */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="done"><span>1</span></li>
								<li className="now">
									<span>2</span>
									<p className="conf" id="step2">保険プランの選択</p>
								</li>
								<li><span>3</span></li>
								<li><span>4</span></li>
							</ul>
						</div>
					</div>
				</div>
				<main className="page-plan">
					<WprContainer view={this.view} mode="viewMode2.表示">
						<div className="fixedplan" data-fixedplan="">
							<ul data-checked-type="">
								<WprLi className="reasonable" view={this.view} name="reasonablebtn">
									<label className="rect" htmlFor="lb-type-reasonable">
										<span className="name"><WprSpan name="reasonableSummary" view={this.view}/><br/><em>お守りに</em>
										<small><WprSpan name="reasonableName" view={this.view} /></small></span>
										<span className="price"><em><WprText className="planPrice" name="reasonableFee" converter="3桁カンマ" view={this.view} /></em><span>円</span></span>
									</label>
								</WprLi>
								<WprLi className="standard" view={this.view} name="standardbtn">
									<label className="rect" htmlFor="lb-type-standard">
										<span className="name"><WprSpan name="standardSummary" view={this.view}/><br/><em>おすすめ</em>
										<small><WprSpan name="standardName" view={this.view} /></small></span>
										<span className="price"><em><WprText className="planPrice" name="standardFee" converter="3桁カンマ" view={this.view} /></em><span>円</span></span>
									</label>
								</WprLi>
								<WprLi className="premium" view={this.view} name="premiumbtn">
									<label className="rect" htmlFor="lb-type-premium">
										<span className="name"><WprSpan name="premiumSummary" view={this.view}/><br/><em>あんしん</em>
										<small><WprSpan name="premiumName" view={this.view} /></small></span>
										<span className="price"><em><WprText className="planPrice" name="premiumFee" converter="3桁カンマ" view={this.view} /></em><span>円</span></span>
									</label>
								</WprLi>
							</ul>
						</div>
					</WprContainer>
					<section className="selectplan">
						<div className="top"><h2>ご希望のプランを<br className="sp"/>チェックしてください</h2></div>
						<div className="plan">
							<div className="types">
								<ul>
									<li className="reasonable" id="reasonable">
										<WprRadio className="select" name="type" id="lb-type-reasonable" value="reasonable" view={this.view} />
										<label className="rect" htmlFor="lb-type-reasonable" id="lb-type-reasonable-lbl" onClick={e => this.handleClick(e, this.props)}>
											<div>
												<div className="img"></div>
												<p><span className="copy"><WprSpan name="reasonableSummary" view={this.view}/><br/><em>お守りに</em></span></p>
												<p><em><WprSpan className="price" name="reasonableFee" converter="3桁カンマ" view={this.view} /></em><span>円</span></p>
											</div>
										</label>
										<p className="name"><WprSpan name="reasonableName" view={this.view} /></p>
									</li>
									<li className="standard" id="standard">
										<WprRadio className="select" name="type" id="lb-type-standard" value="standard" view={this.view} />
										<label className="rect" htmlFor="lb-type-standard" id="lb-type-standard-lbl" onClick={e => this.handleClick(e, this.props)}>
											<div>
												<div className="img"></div>
												<p><span className="copy"><WprSpan name="standardSummary" view={this.view}/><br/><em>おすすめ</em></span></p>
												<p><em><WprSpan className="price" name="standardFee" converter="3桁カンマ" view={this.view} /></em><span>円</span></p>
											</div>
										</label>
										<p className="name"><WprSpan name="standardName" view={this.view} /></p>
									</li>
									<li className="premium" id="premium">
										<WprRadio className="select" name="type" id="lb-type-premium" value="premium" view={this.view} />
										<label className="rect" htmlFor="lb-type-premium" id="lb-type-premium-lbl" onClick={e => this.handleClick(e, this.props)}>
											<div>
												<div className="img"></div>
												<p><span className="copy"><WprSpan name="premiumSummary" view={this.view}/><br/><em>あんしん</em></span></p>
												<p><em><WprSpan className="price" name="premiumFee" converter="3桁カンマ" view={this.view} /></em><span>円</span></p>
											</div>
										</label>
										<p className="name"><WprSpan name="premiumName" view={this.view} /></p>
									</li>
								</ul>
								<div className="attention">
									<p className="multiple">
										※　全て1人分の保険料です。
									{/* WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 START */}
										<WprContainer view={this.view} mode='表示_OTA'>
											<br /><p className='fw700 ota'>※　出発日時点で満79歳以下（疾病死亡補償がある場合満69歳以下）の方対象</p>
										</WprContainer>
									{/* WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 END */}
									</p>
									<p className="c-quest-s">をクリックすると説明が表示されます。</p>
									{/* WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START */}
									<p className="multiple">
										<WprContainer view={this.view} mode='表示_OTA'>
											<a href='https://www.zurich.co.jp/travel/ota/document/' target='_blank'>商品概要・約款・ハンドブックはこちら</a>
										</WprContainer>
										<WprContainer view={this.view} mode='表示_DTP'>
											<a href='https://www.zurich.co.jp/travel/dta/document/' target='_blank'>商品概要・約款はこちら</a>
										</WprContainer>
									</p>
									{/* WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END */}
								</div>
							</div>
							<div className="lists">
								<div className="list">
									<div className="tit">
										<h4><WprSpan name="label1" view={this.view} /></h4>
										<WprButton className="c-quest-b" name="q-1" view={this.view}></WprButton>
									</div>
									<ul datachecked-type="">
										<WprLi name="li1_1" view={this.view}>
											<p><WprSpan name="value1_1" view={this.view} /></p>
										</WprLi>
										<WprLi name="li2_1" view={this.view}>
											<p><WprSpan name="value2_1" view={this.view} /></p>
										</WprLi>
										<WprLi name="li3_1" view={this.view}>
											<p><WprSpan name="value3_1" view={this.view} /></p>
										</WprLi>
									</ul>
								</div>
								<div className="list">
									<div className="tit">
										<h4><WprSpan name="label2" view={this.view} /></h4>
										<WprButton className="c-quest-b" name="q-2" view={this.view}></WprButton>
									</div>
									<ul data-checked-type="">
										<WprLi name="li1_2" view={this.view}>
											<p><WprSpan name="value1_2" view={this.view} /></p>
										</WprLi>
										<WprLi name="li2_2" view={this.view}>
											<p><WprSpan name="value2_2" view={this.view} /></p>
										</WprLi>
										<WprLi name="li3_2" view={this.view}>
											<p><WprSpan name="value3_2" view={this.view} /></p>
										</WprLi>
									</ul>
								</div>
								{/* WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START */}
								<WprContainer mode="表示_DTP" view={this.view} >
									<div className="list">
										<div className="tit">
											<h4><WprSpan name="label8" view={this.view} /></h4>
											<WprButton className="c-quest-b" name="q-8" view={this.view}></WprButton>
										</div>
										<ul data-checked-type="">
											<WprLi name="li1_8" view={this.view}>
												<p><WprSpan name="value1_8" view={this.view} /></p>
											</WprLi>
											<WprLi name="li2_8" view={this.view}>
												<p><WprSpan name="value2_8" view={this.view} /></p>
											</WprLi>
											<WprLi name="li3_8" view={this.view}>
												<p><WprSpan name="value3_8" view={this.view} /></p>
											</WprLi>
										</ul>
									</div>
								</WprContainer>
								{/* WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END */}
								<div className="list">
									<div className="tit">
										<h4><WprSpan name="label3" view={this.view} /></h4>
										<WprButton className="c-quest-b" name="q-3" view={this.view}></WprButton>
									</div>
									<ul data-checked-type="">
										<WprLi name="li1_3" view={this.view}>
											<p><WprSpan name="value1_3" view={this.view} /></p>
										</WprLi>
										<WprLi name="li2_3" view={this.view}>
											<p><WprSpan name="value2_3" view={this.view} /></p>
										</WprLi>
										<WprLi name="li3_3" view={this.view}>
											<p><WprSpan name="value3_3" view={this.view} /></p>
										</WprLi>
									</ul>
								</div>
								<div className="list">
									<div className="tit">
										<h4><WprSpan name="label4" view={this.view} /></h4>
										<WprButton className="c-quest-b" name="q-4" view={this.view}></WprButton>
									</div>
									<ul data-checked-type="">
										<WprLi name="li1_4" view={this.view}>
											<p><WprSpan name="value1_4" view={this.view} /></p>
										</WprLi>
										<WprLi name="li2_4" view={this.view}>
											<p><WprSpan name="value2_4" view={this.view} /></p>
										</WprLi>
										<WprLi name="li3_4" view={this.view}>
											<p><WprSpan name="value3_4" view={this.view} /></p>
										</WprLi>
									</ul>
								</div>
								<div className="list">
									<div className="tit">
										<h4><WprSpan name="label5" view={this.view} /></h4>
										<WprButton className="c-quest-b" name="q-5" view={this.view}></WprButton>
									</div>
									<ul data-checked-type="">
										<WprLi name="li1_5" view={this.view}>
											<p><WprSpan name="value1_5" view={this.view} /></p>
										</WprLi>
										<WprLi name="li2_5" view={this.view}>
											<p><WprSpan name="value2_5" view={this.view} /></p>
										</WprLi>
										<WprLi name="li3_5" view={this.view}>
											<p><WprSpan name="value3_5" view={this.view} /></p>
										</WprLi>
									</ul>
								</div>
								<div className="list">
									<div className="tit">
										<h4><WprSpan name="label6" view={this.view} /></h4>
										<WprButton className="c-quest-b" name="q-6" view={this.view}></WprButton>
									</div>
									<ul data-checked-type="">
										<WprLi name="li1_6" view={this.view}>
											<p><WprSpan name="value1_6" view={this.view} /></p>
										</WprLi>
										<WprLi name="li2_6" view={this.view}>
											<p><WprSpan name="value2_6" view={this.view} /></p>
										</WprLi>
										<WprLi name="li3_6" view={this.view}>
											<p><WprSpan name="value3_6" view={this.view} /></p>
										</WprLi>
									</ul>
								</div>
							</div>
						</div>
					</section>
					<WprContainer mode='option' view={this.view}>
						<section className="option">
							<div className="circle"></div>
							<div className="wrap">
								<div className="lists">
									<div className="item">
										<WprCheckBox name="yes" id="lb_yes" view={this.view} />
										<label htmlFor="lb_yes"><span className="bubble">チェックで<br/><em>追加</em></span>
											<data className="safety">
											{/* <span className="name">飛行機の遅延・欠航などに備える<br/><em>安心オプションを追加する</em></span> */}
											<WprContainer view={this.view} mode='表示_OTA'>
												<span className="name">航空機の欠航等、思わぬ事態により支出した費用（宿泊代など）を補償する<br/>
												<em>安心オプションを追加する</em></span>
											</WprContainer>
											<WprContainer view={this.view} mode='表示_DTP'>
												<span className="name">航空機の遅延・欠航・着陸地変更等により宿泊した場合に補償する<br/>
												<em>安心オプションを追加する</em></span>
											</WprContainer>
											<span className="price"><em><WprSpan name="optionFee" view={this.view} /></em>円</span></data>
											<data className="stay">
												<WprSpan className="name" name="label7" view={this.view} />
												<WprButton className="stay-quest c-quest-b" name="q-7" data-layer-show="q-7" view={this.view}></WprButton>
												<WprSpan className="price" name="value7" view={this.view} />
											</data>
										</label>
									</div>
								</div>
							</div>
						</section>
					</WprContainer>
					<WprContainer mode='q-7' view={this.view}>
						<div className="c-layer" >
							<div className="box">
								<h1><WprSpan name='extraCollName' view={this.view} /></h1>
								<p><WprSpan name='extraCollDesc' view={this.view} /></p>
								<WprButton className="button" name="close" view={this.view}>閉じる</WprButton>
							</div>
						</div>
					</WprContainer>
					<section className="next">
						<div className="wrap">
							<div className="total">
								<ul>
									<li className="plan">
										<div id="plan-select">
											<div><p><WprSpan name="planName" id="plan-name" view={this.view} /></p></div>
											<div>
												<p>
													<WprSpan name="addOption" id="add-option" view={this.view} />
													{/* <WprSpan name="optionName" id="option-name" view={this.view} /> */}
													<WprContainer view={this.view} mode='option.表示'>
														オプション
													</WprContainer>
												</p>
											</div>
											
										</div>
									</li>
									<li className="sum">
										<p className="ryo">合計保険料</p>
										<p className="price">
											<WprContainer view={this.view} mode='totalPremium.first'>
												<span>-</span>
											</WprContainer>
											<WprContainer view={this.view} mode='totalPremium.selected'>
												<WprSpan converter="3桁カンマ" name="totalPremium" view={this.view} />
											</WprContainer>	
											<span className="yen">円</span>
										</p>
										<p className="attention">※被保険者全員分の保険料です。</p>
									</li>
									<li className="button">
										<WprButton data-next="" name="next" view={this.view}>
											<WprSpan view={this.view} name="buttonName"></WprSpan>
											{/* このプランで次に進む */}
										</WprButton>
									</li>
								</ul>
							</div>
							<div className="prev">
								<WprAnchor view={this.view} name="prev" className="c-btn-prev">
									<span>1つ前の画面に戻る</span>
								</WprAnchor>
							</div>
						</div>
					</section>
				</main>
				{this.renderList('CollDispList')}
				<FooterComponent />
			</>
		);
	}

	/**
	 * リスト描画
	 * @param listName リスト名
	 * @param rowInfo 行情報
	 */
	protected onRenderList(listName: string, rowInfo: WprRowInfo): any {
		if (listName === 'CollDispList') {
			return (
				<div key={rowInfo.index}>
					<WprContainer mode= {'helpMode.' + rowInfo.rowData.collateralKey} view={this.view} >
						<div className="c-layer" >
							<div className="box" >
								<h1><WprSpan name="collName" view={this.view} row={rowInfo} /></h1>
								<p><WprSpan name="collDesc" view={this.view} row={rowInfo} /></p>
								<WprButton className="button" name="close" view={this.view}><span>閉じる</span></WprButton>
							</div>
						</div>
					</WprContainer>
				</div>
			);
		}
		return null;
	}
}

export default withRouter(PlanComponent);